import api from '../utils/api'

export const getSgsItems = async (searchTerm) => {

    try {
        const token = localStorage.getItem('token');
    
        api.defaults.headers.Authorization = `Bearer ${JSON.parse(token)}`

        const data = await api.get(searchTerm ? `/requests/sgs/get-sgs-items${searchTerm}`:`/requests/sgs/get-sgs-items`).then((response) => {
            return response.data
        })

        return data


    } catch (error) {

        return null
        
    }

}

export const directInstall = async (data) => {
    try {
      const token = localStorage.getItem('token');
      api.defaults.headers.Authorization = `Bearer ${JSON.parse(token)}`;
  
      // Simula uma demora de 10 segundos
      // await new Promise(resolve => setTimeout(resolve, 7000));
  
      const response = await api.post(`/requests/sgs/direct-install`, data).then((response) => {
          return response
      })
  
      return "OKOK";
    } catch (error) {
      return null;
    }
  };

  export const getTecnico = async (matricula) => {
    try {
      const token = localStorage.getItem('token');
      api.defaults.headers.Authorization = `Bearer ${JSON.parse(token)}`;
  
      const response = await api.get(`/requests/sgs/get-tecnico?matricula=${matricula}`);
      return response.data;
    } catch (error) {
      console.error("Erro ao buscar técnico:", error);
      return null;
    }
  };

  export const getDefeitos = async () => {
      try {
          const token = localStorage.getItem('token');
          api.defaults.headers.Authorization = `Bearer ${JSON.parse(token)}`;
  
          const data = await api.get('/collectorders/sgs/defeitos').then((response) => {
              return response.data;
          });
  
          return data;
      } catch (error) {
          return null;
      }
  };

const SgsService = {
    getSgsItems,
    directInstall,
    getTecnico,
    getDefeitos
  };
  
  export default SgsService;